import {logForCrashlytics} from 'src/Utils/fireUtils';
export function parsePlayerChallegeData(playerChallengeData) {
  logForCrashlytics('parsePlayerChallegeData fired in dataHelper.js');
  let playerChallengePhotos = [];
  let playerChallengeDataActive = [];
  let playerChallengeDataCompleted = [];
  let playerChallengeDataActiveCount = 0;
  let playerChallengeDataCount = 0;

  const timeNow = Date.now();
  playerChallengeData &&
    Object.values(playerChallengeData).map?.((challenge) => {
      playerChallengeDataCount++;
      if (challenge.pointsEarned > -1) {
        playerChallengeDataCompleted?.push?.(challenge);

        if (challenge.photoUrl) {
          playerChallengePhotos.push({
            challenge: challenge.task,
            downloadURL: challenge.photoUrl,
            userId: challenge.userId,
            pointsEarned: challenge.pointsEarned,
            shareUUID: challenge.shareUUID || '',
            type: 'Player',
            isVideo: challenge.isVideo || false,
            thumbnail: challenge.thumbnail || '',
          });
        }
      } else if (challenge.deliveryTime <= timeNow) {
        playerChallengeDataActive.push(challenge);
        playerChallengeDataActiveCount++;
      }
    });
  return {
    playerChallengeData,
    playerChallengePhotos,
    playerChallengeDataActive,
    playerChallengeDataCompleted,
    playerChallengeDataActiveCount,
    playerChallengeDataCount,
  };
}

export const parseHTML = (text) => {
  return (
    text
      ?.replace?.(/<br>/gi, '')
      .replace(/&nbsp;/gi, '')
      .replace(/<p><\/p>/gi, '')
      .replace(/<p[^>]*>[\s|&nbsp;]*<\/p>/, '')
      .replace(/style="[\w\W][^"]*"/gi, '')
      .replace(/style'[\w\W][^']*'/gi, '')
      .replace(/&nbsp;/gi, '')
      .replace(/<\/p><p>/gi, '\n\n')
      .replace(/<\/p>/gi, '')
      .replace(/<p>/gi, '')
      .replace(/&#700;/g, `'`)
      .replace(/&#8221;/g, '"')
      .replace(/&#8212;/g, ', ')
      .replace(/&#8220;/g, '"')
      .replace(/(<p[^>]+?>|<p>|<\/p>)/i, '')
      .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '\n\n') || ''
  );
};
